import header from '../constants/header'

export default {
  /**
   * sessionStrageへのデータ登録
   */
  
  getTitle: (route) => {
    switch (route.split('/')[1]) {
      case '': return header.header.admin
      case 'admin_referral_fee': return header.header.advertisementfee
      case 'admin_rating_check': return header.header.commentReview
      case 'company_specified_commercial_transaction': return header.header.commercialTransactions
      case 'company_privacy_policy': return header.header.privacyPolicy
      case 'company_antisocial': return header.header.antiSocial
      case 'company_policy': return header.header.termOfUse
      case 'company_publication_rules': return header.header.publicRule
      case 'company_payment': return header.header.companyPayment
      case 'admin_company':
        switch (route.split('/')[2]){
          case undefined: return header.header.adminCompany
          case 'detail': return header.header.companyDetail
      }
      case 'admin_user':
        switch (route.split('/')[2]){
          case undefined: return header.header.admin
          case 'detail': return header.header.adminDetail
          case 'create': return header.header.addAdmin
      }
      case 'admin_offer':
        switch (route.split('/')[2]){
          case 'detail': return header.header.jobSearchDetail
          case undefined: return header.header.jobSearch
      }
      case 'admin_offer_user':
        switch (route.split('/')[2]){
          case 'detail': return header.header.memberDetail
          case undefined: return header.header.member
      }
      case 'company_detail':
        switch (route.split('/')[2]){
          case 'user': return header.header.companyUserDetail
          case 'comment': return header.header.commentDetail
          case undefined: return header.header.company
      }
      case 'company_offer':
        switch (route.split('/')[2]){
          case 'detail': return header.header.jobInformation
          case 'draft': return header.header.jobSearch
          case 'job_information': return header.header.jobInformation
          case undefined: return header.header.jobSearch
      }
      break
    }
  }
}
